module.exports = {
  'en': {
    'HRES6MEC1': {
      '5': 'Start Request Date',
      '7': 'To',
      '10': 'Request Date',
      '20': 'Seq.',
      '30': 'Leave Code',
      '40': 'Leave Period',
      '50': 'Status of Cancel',
      '60': 'Remarks Approve',
      '70': 'Last Approver',
      '80': 'Status Leave',
      '90': 'Req. Date',
      '99': 'Request for Cancle Leave Application',
      '100': 'Leave No',
      '110': 'Next Step Approval'
    },
    'HRES6MEC2': {
      '20': 'Date',
      '25': 'Seq. No.',
      '30': 'Leave Code',
      '40': 'From Date',
      '50': 'To Date',
      '60': 'Remark',
      '70': 'Leave Detail',
      '80': 'From Time',
      '90': 'To Time',
      '200': 'Full Day',
      '210': 'First Half',
      '220': '2nd Half',
      '230': 'By Hours',
      '250': 'Type of Leave'
    }
  },
  'th': {
    'HRES6MEC1': {
      '5': 'วันที่ขอตั้งแต่',
      '7': 'ถึง',
      '10': 'วันที่ขอ',
      '20': 'ลำดับที่',
      '30': 'รหัสการลา',
      '40': 'ช่วงวันที่ลา',
      '50': 'สถานะ การขอยกเลิก',
      '60': 'หมายเหตุการอนุมัติ',
      '70': 'ผู้อนุมัติล่าสุด',
      '80': 'สถานะใบลา',
      '90': 'วันที่ขอยกเลิก',
      '99': 'คำร้องขอยกเลิกลาหยุดงาน',
      '100': 'เลขที่ใบลา',
      '110': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES6MEC2': {
      '20': 'วันที่ขอ',
      '25': 'ลำดับที่',
      '30': 'รหัสการลา',
      '40': 'ตั้งแต่วันที่',
      '50': 'ถึงวันที่',
      '60': 'หมายเหตุการยกเลิก',
      '70': 'รายละเอียดการลา',
      '80': 'ตั้งแต่เวลา',
      '90': 'ถึงเวลา',
      '200': 'เต็มวัน',
      '210': 'ครึ่งแรก',
      '220': 'ครึ่งหลัง',
      '230': 'กำหนดเอง',
      '250': 'ประเภทการลา'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres6me.js